import "./PrivacyPolicyTerms.module.css";
import Navbar from "@/reusable_sections/Header";
import Privacy from "./sections/Privacy";
import Terms from "./sections/Terms";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyTermsPage() {
  return <div>
      <Navbar />
      <Privacy />
      <Terms />
      <Footer />
    </div>;
}